module.exports = __webpack_public_path__ + "img/xmasParty20.b4dba97b.jpg";